/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPhoneForwarded(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M17.914 1.006a.75.75 0 011.06 0l4 4a.75.75 0 010 1.06l-4 4a.75.75 0 11-1.06-1.06l2.72-2.72h-6.19a.75.75 0 010-1.5h6.19l-2.72-2.72a.75.75 0 010-1.06zM7.389 3.588c-.321-.276-.694-.302-1.43-.302H3.554a1.25 1.25 0 00-1.243 1.357 19.04 19.04 0 002.953 8.335l.003.006a18.75 18.75 0 005.77 5.769l.005.004a19.04 19.04 0 008.296 2.952 1.252 1.252 0 001.251-.744c.047-.107.087-.32.101-.695.009-.235.007-.476.005-.743 0-.155-.002-.318 0-.495.002-.584-.003-1.137-.06-1.603-.06-.497-.162-.742-.237-.83a1.25 1.25 0 00-.776-.43 13.564 13.564 0 01-2.97-.74l-.002-.001a1.25 1.25 0 00-1.317.28l-.002.001-1.267 1.267a.75.75 0 01-.9.122 16.75 16.75 0 01-6.282-6.281.75.75 0 01.122-.901L8.27 8.649l.001-.002a1.25 1.25 0 00.28-1.317v-.002a13.59 13.59 0 01-.74-2.97 1.25 1.25 0 00-.423-.77zM6.028 1.786c.649-.001 1.563-.002 2.339.665a2.75 2.75 0 01.93 1.7v.007c.12.904.341 1.791.66 2.646l-.703.262.702-.264a2.75 2.75 0 01-.619 2.901l-.003.003-.858.858a15.252 15.252 0 004.94 4.94l.858-.858.003-.003a2.749 2.749 0 012.9-.62 12.088 12.088 0 002.645.66h.007a2.75 2.75 0 011.714.946c.38.449.517 1.083.582 1.621.068.57.072 1.21.07 1.79-.002.136 0 .28 0 .428.002.291.004.593-.006.858-.015.395-.057.854-.225 1.24a2.75 2.75 0 01-2.767 1.637l-.014-.001a20.54 20.54 0 01-8.954-3.185 20.25 20.25 0 01-6.226-6.226A20.54 20.54 0 01.818 4.795v-.012a2.75 2.75 0 012.735-2.997h2.475z'
        />
      </g>
      <defs>
        <clipPath id='phone-forwarded_svg__clip0_126_10335'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgPhoneForwarded;
